<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-accordion id="accordion"  [multiple]="false" (onOpen)="abrirAcordeon($event)">
        <p-accordionTab header="{{ 'PERFILRIESGO.LBL_INFOPERFIL' | translate }}" [selected]="tabSeleccionado === 'INFO'">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fPerfil" name="fPerfil">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'PERFILRIESGO.LBL_CODIGO' | translate }}</label>
                  <div *ngIf="!perfil">
                    <input type="text" pInputText id="codigo"
                           name="nomCodigo"
                           autocomplete="off"
                           formControlName="codigo"
                           maxlength="10"
                           (blur)="validarCodigo()"
                           codigos-reactive
                    >
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                      {{ 'PERFILRIESGO.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                      {{ 'MSG_CODIGOEXISTE' | translate}}
                    </div>
                  </div>
                  <div *ngIf="perfil && perfil.idPerfilRiesgo">
                    <label class="falso-combo-texto">{{perfil.codigo}}</label>
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'PERFILRIESGO.LBL_NOMBRERIESGO' | translate }}</label>
                  <input type="text" pInputText id="nombre"
                         name="nomNombre"
                         autocomplete="off"
                         formControlName="nombreRiesgo"
                         [maxlength]="100"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombreRiesgo.invalid">
                    {{ 'PERFILRIESGO.LBL_NOMBRERIESGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-12 lg:col-12">
                <div class="div-form">
                  <label>{{ 'PERFILRIESGO.LBL_DESCRIPCION' | translate }}</label>
                  <textarea id="idDescripcion" name="nomDescripcion" pInputTextarea rows="2"
                            capitalize-reactive maxlength="500"
                            formControlName="descripcion"></textarea>
                </div>
              </div>
            </div>

            <div class="grid form-group">

              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>{{ 'PERFILRIESGO.LBL_RANGOSCORE' | translate }}</label>
                  <input type="text" pInputText id="idRangoMinimo"
                         name="nomRangoMinimo"
                         autocomplete="off"
                         formControlName="rangoMinimo"
                         [maxlength]="15"
                         numero-entero-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="superaMaximo">
                    {{ 'LBL_RANGOINVALIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label><br></label>
                  <input type="text" pInputText id="idRangoMaximo"
                         name="nomRangoMaximo"
                         autocomplete="off"
                         formControlName="rangoMaximo"
                         [maxlength]="15"
                         numero-entero-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="superaMaximo">
                    {{ 'LBL_RANGOINVALIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <img *ngIf="!carImagen && imagen" style="height: 100px" [src]="imagen" alt=""/>
                <br>
                <div class="div-form">
                  <p-fileUpload name="file" url="{{svcThUrl}}" [auto]="false" class="upload-avatar"
                                chooseLabel="{{'LBL_SUBIRIMAGEN' | translate}}"
                                (onBeforeUpload)="onBeforeSend($event)" mode="basic" [hidden]="carImagen"
                                (onValidSelect)="onSelect($event, $event.files)" fSize
                                (onUpload)="onUpload($event)" accept="image/*"
                  ></p-fileUpload>
                  <div *ngIf="carImagen">
                    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                    <span>{{'LBL_CARGANDO' | translate }}</span>
                  </div>
                  <br>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idAdjunto.invalid && !carImagen">
                    {{ 'PERFILRIESGO.LBL_IMAGENPERFIL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-3 lg:col-3">
                <div class="div-form">
                  <label>* {{ 'PERFILRIESGO.LBL_CAUSALDENEGACION' | translate }}</label>
                  <p-dropdown disableTab  id="idCausal" name="nomCausal" [options]="lisCausales"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idCausalSolicitud"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCausalSolicitud.invalid">
                    {{ 'PERFILRIESGO.LBL_CAUSALDENEGACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-3 lg:col-3">
                <p-checkbox label="{{ 'PERFILRIESGO.LBL_CONSULTAAUTO' | translate}}" binary="true"
                            id="indicadorConsultaAutomatica"
                            name="nomIndicadorConsultaAutomatica"
                            formControlName="indicadorConsultaAutomatica"
                            (onChange)="validarConsultaAutomatica()"></p-checkbox>
              </div>
              <div class="col-12 md:col-3 lg:col-3" *ngIf="f.indicadorConsultaAutomatica.value">
                <div class="div-form">
                  <label>* {{ 'PERFILRIESGO.LBL_FRECDIAS' | translate }}</label>
                  <input type="text" pInputText id="frecuenciaDias"
                         name="nomFrecuenciaDias"
                         autocomplete="off"
                         formControlName="frecuenciaDias"
                         [maxlength]="2"
                         numero-entero-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.frecuenciaDias.invalid">
                    {{ 'PERFILRIESGO.LBL_FRECDIAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-3 lg:col-3" *ngIf="f.indicadorConsultaAutomatica.value">
                <div class="div-form">
                  <label>* {{ 'PERFILRIESGO.LBL_ESTADOSCAMBIO' | translate }}</label>
                  <p-dropdown disableTab  id="idEstadoCambio" name="nomIdEstadoCambio" [options]="lisEstados"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idEstadoCambio"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstadoCambio.invalid">
                    {{ 'PERFILRIESGO.LBL_ESTADOSCAMBIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-3 lg:col-3">
                <p-checkbox label="{{ 'PERFILRIESGO.LBL_MANEJACICLOS' | translate}}" binary="true"
                            id="idIndicadorManejaCiclos"
                            name="nomIndicadorManejaCiclos"
                            formControlName="indicadorManejaCiclos"></p-checkbox>
              </div>
              <div class="col-12 md:col-3 lg:col-3">
                <p-checkbox label="{{ 'PERFILRIESGO.LBL_CAMBIOESTADO' | translate}}" binary="true"
                            id="indicadorCambioEstado"
                            name="nomIndicadorCambioEstado"
                            formControlName="indicadorCambioEstado"
                            (onChange)="validarCambioEstado()"></p-checkbox>
              </div>
              <div class="col-12 md:col-3 lg:col-3" *ngIf="f.indicadorCambioEstado.value">
                <div class="div-form">
                  <label>* {{ 'PERFILRIESGO.LBL_ESTADOS' | translate }}</label>
                  <p-dropdown disableTab  id="idEstado" name="nomIdEstado" [options]="lisEstados"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idEstado"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstado.invalid">
                    {{ 'PERFILRIESGO.LBL_ESTADOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-3 lg:col-3">
                <div class="div-form">
                  <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                              id="indicador"
                              name="nomIndicador"
                              formControlName="indicadorHabilitado"></p-checkbox>
                </div>

              </div>
              <div class="col-12 md:col-3 lg:col-3">
                <div class="div-form">
                  <p-checkbox label="{{ 'PERFILRIESGO.LBL_SCORE' | translate}}" binary="true"
                              id="indicadorScore"
                              name="indicadorScore"
                              formControlName="indicadorScore"></p-checkbox>
                </div>

              </div>
            </div>

            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-plus" label="{{((perfil && perfil.idPerfilRiesgo) ? 'BTN_ACTUALIZAR' : 'BTN_CREAR') | translate }}"
                          type="submit"
                          pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab header="{{ 'PERFILRIESGO.LBL_ASIGNARTASA' | translate }}" [selected]="tabSeleccionado === 'TASA'"
                        [disabled]="!perfil">
          <app-perfiles-riesgo-tasa [perfil]="perfil" *ngIf="perfil && perfil.idPerfilRiesgo && tabSeleccionado === 'TASA'"
                                    (dismiss)="cambiarTabSeleccionado($event)"></app-perfiles-riesgo-tasa>
        </p-accordionTab>
        <p-accordionTab header="{{ 'PERFILRIESGO.LBL_ASIGNARCICLO' | translate }}" [selected]="tabSeleccionado === 'CICLO'"
                        [disabled]="!perfil"
                        *ngIf="perfil  && perfil.indicadorManejaCiclos">
          <app-perfiles-riesgo-ciclo [perfil]="perfil" *ngIf="perfil && perfil.idPerfilRiesgo && tabSeleccionado === 'CICLO'" (dismiss)="cambiarTabSeleccionado($event)"></app-perfiles-riesgo-ciclo>
        </p-accordionTab>
        <p-accordionTab header="{{ 'PERFILRIESGO.LBL_ASIGNARSCORE' | translate }}" [selected]="tabSeleccionado === 'SCORE'"
                        [disabled]="!perfil"
                        *ngIf="perfil  && perfil.indicadorScore">
          <app-asignar-score [perfil]="perfil" *ngIf="perfil && perfil.idPerfilRiesgo && tabSeleccionado === 'SCORE'" ></app-asignar-score>
        </p-accordionTab>
      </p-accordion>
      <div class="grid form-footer-buttons" *ngIf="perfil && perfil.idPerfilRiesgo">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
